module.exports = __webpack_public_path__ + "img/fruitbowl.b65f3f14.png";